import { render } from "./UpgradePlans.vue?vue&type=template&id=3ed3daa3&ts=true"
import script from "./UpgradePlans.vue?vue&type=script&lang=ts"
export * from "./UpgradePlans.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__